import { Component, Input, HostBinding } from "@angular/core";
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function SuiProgress_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.percentage, "%");
} }
var _c0 = ["*"];
var SuiProgress = /** @class */ (function () {
    function SuiProgress() {
        this._popupClasses = true;
        this.value = 0;
        this.maximum = 100;
        this.precision = 0;
        this._overrideSuccess = false;
        this.autoSuccess = true;
        this.showProgress = true;
        this._popupClasses = true;
    }
    Object.defineProperty(SuiProgress.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            // Convert value from string to number where necessary.
            var converted = +value;
            if (Number.isNaN(converted)) {
                return;
            }
            this._value = converted;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiProgress.prototype, "maximum", {
        get: function () {
            return this._maximum;
        },
        set: function (value) {
            // Convert value from string to number where necessary.
            var converted = +value;
            if (Number.isNaN(converted)) {
                return;
            }
            this._maximum = converted;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiProgress.prototype, "precision", {
        get: function () {
            return this._precision;
        },
        set: function (value) {
            // Convert value from string to number where necessary.
            var converted = +value;
            if (Number.isNaN(converted)) {
                return;
            }
            this._precision = Math.min(Math.max(converted, 0), 20);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiProgress.prototype, "_reachedMaximum", {
        get: function () {
            return this._overrideSuccess || ((this.value >= this.maximum) && this.autoSuccess);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiProgress.prototype, "percentage", {
        get: function () {
            var boundedValue = Math.min(Math.max(this.value, 0), this.maximum);
            var percentage = (boundedValue / this.maximum) * 100;
            return percentage.toFixed(this.precision);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiProgress.prototype, "classValue", {
        set: function (classes) {
            if (classes.includes("attached") || classes.includes("tiny")) {
                this.showProgress = false;
            }
            if (classes.includes("success")) {
                this._overrideSuccess = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */
    SuiProgress.ctorParameters = function () { return []; };
    SuiProgress.propDecorators = {
        "_popupClasses": [{ type: HostBinding, args: ["class.ui",] }, { type: HostBinding, args: ["class.progress",] },],
        "autoSuccess": [{ type: Input },],
        "showProgress": [{ type: Input },],
        "value": [{ type: Input },],
        "maximum": [{ type: Input },],
        "precision": [{ type: Input },],
        "_reachedMaximum": [{ type: HostBinding, args: ["class.success",] },],
        "percentage": [{ type: HostBinding, args: ["attr.data-percent",] },],
        "classValue": [{ type: Input, args: ["class",] },],
    };
SuiProgress.ɵfac = function SuiProgress_Factory(t) { return new (t || SuiProgress)(); };
SuiProgress.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SuiProgress, selectors: [["sui-progress"]], hostVars: 7, hostBindings: function SuiProgress_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-percent", ctx.percentage);
        ɵngcc0.ɵɵclassProp("ui", ctx._popupClasses)("progress", ctx._popupClasses)("success", ctx._reachedMaximum);
    } }, inputs: { value: "value", maximum: "maximum", precision: "precision", autoSuccess: "autoSuccess", showProgress: "showProgress", classValue: ["class", "classValue"] }, ngContentSelectors: _c0, decls: 4, vars: 3, consts: [[1, "bar"], ["class", "progress", 4, "ngIf"], [1, "label"], [1, "progress"]], template: function SuiProgress_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, SuiProgress_div_1_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.percentage, "%");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showProgress);
    } }, directives: [ɵngcc1.NgIf], styles: [".bar[_ngcontent-%COMP%] {\n    transition-duration: 300ms !important;\n    z-index: 1;\n}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuiProgress, [{
        type: Component,
        args: [{
                selector: "sui-progress",
                template: "\n<div class=\"bar\" [style.width.%]=\"percentage\">\n    <div class=\"progress\" *ngIf=\"showProgress\">{{ percentage }}%</div>\n</div>\n<div class=\"label\">\n    <ng-content></ng-content>\n</div>\n",
                styles: ["\n.bar {\n    transition-duration: 300ms !important;\n    z-index: 1;\n}\n"]
            }]
    }], function () { return []; }, { _popupClasses: [{
            type: HostBinding,
            args: ["class.ui"]
        }, {
            type: HostBinding,
            args: ["class.progress"]
        }], value: [{
            type: Input
        }], maximum: [{
            type: Input
        }], precision: [{
            type: Input
        }], autoSuccess: [{
            type: Input
        }], showProgress: [{
            type: Input
        }], _reachedMaximum: [{
            type: HostBinding,
            args: ["class.success"]
        }], percentage: [{
            type: HostBinding,
            args: ["attr.data-percent"]
        }], classValue: [{
            type: Input,
            args: ["class"]
        }] }); })();
    return SuiProgress;
}());
export { SuiProgress };

